(function() {
  let lightboxInstance = null;
  let retryTimer = null;
  let retryCount = 0;
  const MAX_RETRIES = 50;

  const depsReady = () =>
    typeof PhotoSwipeLightbox !== 'undefined' &&
    typeof PhotoSwipe !== 'undefined';

  const buildLightbox = () => {
    if (!depsReady()) return false;
    if (!document.querySelector('.splide__gallery')) return false;

    if (lightboxInstance) return true;

    const leftArrowSVGString =
      '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';

    const closeSvgString =
      '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';

    lightboxInstance = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      children: '.product-media-zoom',
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: true,
      counter: true,
      zoom: true,
      wheelToZoom: true,
      bgClickAction: false,
      tapAction: false,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString,
      pswpModule: PhotoSwipe
    });

    lightboxInstance.addFilter('domItemData', (itemData, element) => {
      const imageLink = element.querySelector(
        '.product__media-icon-image[data-pswp-src]'
      );

      if (imageLink) {
        itemData.src = imageLink.dataset.pswpSrc || imageLink.href;
        itemData.width =
          Number(imageLink.dataset.pswpWidth) || itemData.width;
        itemData.height =
          Number(imageLink.dataset.pswpHeight) || itemData.height;
      }

      return itemData;
    });

    lightboxInstance.on('afterInit', () => {
      const pswp = lightboxInstance.pswp;
      if (!pswp) return;

      // Luscious persistent PhotoSwipe UI
      const keepUiVisible = () => {
        pswp.element?.classList.add('pswp--ui-visible');
      };

      keepUiVisible();
      pswp.on('change', keepUiVisible);
      pswp.on('zoomPanUpdate', keepUiVisible);
    });

    lightboxInstance.init();
    retryCount = 0;
    return true;
  };

  const scheduleInit = () => {
    if (buildLightbox()) return;
    if (retryCount >= MAX_RETRIES || retryTimer) return;

    retryCount += 1;
    retryTimer = setTimeout(() => {
      retryTimer = null;
      scheduleInit();
    }, 120);
  };

  const reInitLightbox = () => {
    if (window.pswp) return;

    if (lightboxInstance) {
      lightboxInstance.destroy();
      lightboxInstance = null;
    }

    retryCount = 0;
    scheduleInit();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }

  window.addEventListener('load', scheduleInit, { once: true });
  window.addEventListener('pageshow', scheduleInit);

  document.addEventListener('shopify:section:load', reInitLightbox);

  document.addEventListener('quick-view:loaded', function() {
    requestAnimationFrame(reInitLightbox);
  });

  const openProductZoom = (link, event) => {
    const item = link.closest('.product-media-zoom');
    const gallery = item?.closest('.splide__gallery');
    if (!item || !gallery) return false;

    if (!lightboxInstance) {
      buildLightbox();
    }
    if (!lightboxInstance) return false;

    const items = Array.from(gallery.querySelectorAll('.product-media-zoom'));
    const index = items.indexOf(item);
    if (index < 0) return false;

    const pointer = event && typeof event.clientX === 'number'
      ? { x: event.clientX, y: event.clientY }
      : null;

    return lightboxInstance.loadAndOpen(index, { gallery }, pointer);
  };

  document.addEventListener(
    'click',
    function(event) {
      const link = event.target.closest(
        '.product__media-icon-image[data-pswp-src]'
      );

      if (!link) return;

      // Never allow the product zoom control to navigate to the raw CDN image.
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (!openProductZoom(link, event)) {
        scheduleInit();

        let attempts = 0;
        const retryOpen = setInterval(() => {
          attempts += 1;
          if (openProductZoom(link, event) || attempts >= 20) {
            clearInterval(retryOpen);
          }
        }, 100);
      }
    },
    true
  );
})();